import {Injectable} from '@angular/core';
import {Wallet} from '../../domain/model/wallet.model';
import {IApiWalletDTO} from '../dtos/wallet.api.dto';

@Injectable({providedIn: 'root'})
export class WalletMapper {

  fromApiToDomain(dto: IApiWalletDTO): Wallet {
    return new Wallet(
      dto.id,
      dto.name,
      dto.currency,
      dto.available_balance,
      dto.spent_balance
    );
  }

  fromDomainToApi(wallet: Wallet): IApiWalletDTO {
    return {
      id: wallet.id,
      organization_id: '',
      name: wallet.name,
      currency: wallet.currency,
      available_balance: wallet.availableBalance,
      spent_balance: wallet.spentBalance
    };
  }
}
